"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _calendar = _interopRequireDefault(require("../img/calendar.svg"));

var _calendar_hover = _interopRequireDefault(require("../img/calendar_hover.svg"));

var _calendar_disabled = _interopRequireDefault(require("../img/calendar_disabled.svg"));

function _default(palette) {
  return {
    appearance: "url(\"".concat(_calendar["default"], "\")"),
    appearanceHover: "url(\"".concat(_calendar_hover["default"], "\")"),
    appearanceDisabled: "url(\"".concat(_calendar_disabled["default"], "\")"),
    display: 'inline-block',
    zIndex: palette.zOverlay,
    width: 'auto',
    minWidth: 'auto'
  };
}